import { License } from '../types/License';

const API_BASE_URL = import.meta.env.DEV ? 'http://localhost:3000' : '';

export const getUserLicenses = async (): Promise<License[]> => {
  const token = localStorage.getItem('authToken');
  
  try {
    const response = await fetch(`${API_BASE_URL}/api/licenses`, {
      method: 'GET',
      headers: {
        'Authorization': `Bearer ${token}`
      }
    });

    if (!response.ok) {
      throw new Error('Failed to fetch licenses');
    }

    const data = await response.json();
    return data.licenses;
  } catch (error) {
    console.error('Error fetching licenses:', error);
    throw error;
  }
};

export const validateLicense = async (licenseKey: string, hwid: string): Promise<{ valid: boolean; email?: string }> => {
  try {
    const response = await fetch(`${API_BASE_URL}/api/licenses/validate`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({ licenseKey, hwid })
    });

    const data = await response.json();
    
    if (!response.ok) {
      throw new Error(data.message || 'Failed to validate license');
    }

    return data;
  } catch (error) {
    console.error('Error validating license:', error);
    throw error;
  }
};